import { $t } from '@/translations';
import { OrderStatuses, OrderTypes } from '@/core/enums';

const holdEnabled = `${process.env.VUE_APP_GLOBAL_HOLD_ENABLED}`;
const convertEnabled = `${process.env.VUE_APP_ORDER_CONVERT_ENABLED}`;
const editDeleteEnabled = `${process.env.VUE_APP_ORDER_EDIT_DELETE_ENABLED}`;

export function isHoldEnabled() {
    return holdEnabled === 'true';
}

export function isConvertEnabled() {
    return convertEnabled === 'true';
}

export function isEditDeleteEnabled() {
    return editDeleteEnabled === 'true';
}

const typeLabels = {};

typeLabels[OrderTypes.Consumer] = $t('orders.labels.types.cec');
typeLabels[OrderTypes.EDIDropship] = $t('orders.labels.types.ediDropship');
typeLabels[OrderStatuses.AllOrders] = $t('orders.labels.statuses.allOrders');

export const OrderTypeLabels = typeLabels;

const labels = {};

labels[OrderStatuses.Accepted] = $t('consumerOrders.labels.statuses.accepted');
labels[OrderStatuses.InFulfillment] = $t('consumerOrders.labels.statuses.inFulfillment');
labels[OrderStatuses.Shipped] = $t('consumerOrders.labels.statuses.shipped');
labels[OrderStatuses.Backordered] = $t('consumerOrders.labels.statuses.backordered');

if (isHoldEnabled()) {
    labels[OrderStatuses.OnHold] = $t('consumerOrders.labels.statuses.held');
}

labels[OrderStatuses.AllOrders] = $t('consumerOrders.labels.statuses.allOrders');

export const OrderStatusLabels = labels;

export function isBackorder(order) {
    return order.status === OrderStatuses.Backordered;
}

export function isSplitted(order) {
    return order.isSplittable;
}

export function isOrderTypeConsumer(order) {
    return order.orderType === OrderTypes.Consumer;
}

export function isOrderTypeBusiness(order) {
    return order.orderType === OrderTypes.Business;
}

export function isOrderTypeEDIWholesale(order) {
    return order.orderType === OrderTypes.EDIWholesale;
}

export function isOrderTypeEDIDropship(order) {
    return order.orderType === OrderTypes.EDIDropship;
}

export function isHeld(order) {
    return order.status === 'OnHold';
}

export function orderAddress(order) {
    let address = '';

    if (order.streetAddress1) {
        if (order.streetAddress2) {
            if (order.streetAddress3) {
                address += `${order.streetAddress1}, ${order.streetAddress2}, ${order.streetAddress3}`;
            } else {
                address += `${order.streetAddress1}, ${order.streetAddress2}`;
            }
        } else {
            address += order.streetAddress1;
        }
    }

    if (order.city) {
        if (address !== '') {
            address += ', ';
        }

        address += order.city;
    }

    if (order.stateOrProvince) {
        if (address !== '') {
            address += ', ';
        }

        address += order.stateOrProvince;

        if (order.zipCode) {
            address += ` ${order.zipCode}`;
        }
    } else if (order.zipCode) {
        if (address !== '') {
            address += ', ';
        }

        address += order.zipCode;
    }

    if (order.country) {
        if (address !== '') {
            address += ', ';
        }

        address += order.country;
    }

    return address;
}

export function canBeDeleted(order) {
    return isEditDeleteEnabled() && (order.status === OrderStatuses.Accepted
        || order.status === OrderStatuses.OnHold);
}

export function canBeEdited(order) {
    return isEditDeleteEnabled() && isOrderTypeConsumer(order) && (order.status === OrderStatuses.Accepted
        || order.status === OrderStatuses.InFulfillment
        || order.status === OrderStatuses.ReadyForPickup
        || order.status === OrderStatuses.PackingComplete
        || isBackorder(order)
        || order.status === OrderStatuses.OnHold);
}

export function canBeHeld(order) {
    return order.status === OrderStatuses.Accepted
        && order.orderType !== OrderTypes.EDIDropship
        && isHoldEnabled();
}

export function canBeReleased(order) {
    return order.status === OrderStatuses.OnHold
        && isHoldEnabled();
}

export default OrderStatuses;
